(function () {
  "use strict";

  function initWidget(widget) {
    var video = widget.querySelector(".floating-video__el");
    var toggleZone = widget.querySelector("[data-floating-video-toggle]");
    var closeBtn = widget.querySelector("[data-floating-video-close]");
    var storageKey = "floatingVideoDismissed:" + widget.id;

    if (!video || !toggleZone) return;

    // Respect a prior dismissal for this browser session
    try {
      if (sessionStorage.getItem(storageKey) === "1") {
        widget.classList.add("is-closed");
        video.pause();
        return;
      }
    } catch (e) {
      /* sessionStorage unavailable — widget just stays visible */
    }

    function togglePlay() {
      if (video.paused) {
        video.play();
        widget.classList.remove("is-paused");
      } else {
        video.pause();
        widget.classList.add("is-paused");
      }
    }

    toggleZone.addEventListener("click", togglePlay);
    toggleZone.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        togglePlay();
      }
    });

    if (closeBtn) {
      closeBtn.addEventListener("click", function (e) {
        e.stopPropagation();
        widget.classList.add("is-closed");
        video.pause();
        try {
          sessionStorage.setItem(storageKey, "1");
        } catch (e2) {
          /* ignore */
        }
      });
    }
  }

  function init() {
    document.querySelectorAll("[data-floating-video]").forEach(initWidget);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
